import req from "../http";

const chart = {
  // 取得 階段佔比圖表
  getRecruitProgress(params) {
    return req("get", "/Report/RecruitProgress/Chart", params);
  },

  downloadRecruitProgress(params) {
    return req("get", "/Report/RecruitProgress/Export", params, { responseType: "blob" });
  }
};

export default chart;